import { render, staticRenderFns } from "./CardFile.vue?vue&type=template&id=147f7ccd&scoped=true"
import script from "./CardFile.vue?vue&type=script&lang=js"
export * from "./CardFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147f7ccd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('147f7ccd')) {
      api.createRecord('147f7ccd', component.options)
    } else {
      api.reload('147f7ccd', component.options)
    }
    module.hot.accept("./CardFile.vue?vue&type=template&id=147f7ccd&scoped=true", function () {
      api.rerender('147f7ccd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Folder/CardFile.vue"
export default component.exports